export const PATH={
    WELCOMESCREEN : '/',
    LOGIN : '/login',
    REGISTER : '/register',
    HOME : '/home',
    ACTIVITY:"/activity",
    LEADS : '/leads',
    ADD_LEADS:'/leads/:type?/:edit?',
    PROJECTS : '/projects',
    FORGOTPASSWORD: '/forgotpassword',
    USERTABLE: '/usertable',

}